import { AppFeature } from './types';

/**
 * States in which a feature is georestricted (no access from a license/market
 * in one of these states).
 *
 * Source of truth is the graph-api util `hasAccessToGeorestrictedFeature.ts`
 * (`RESTRICTED_STATES_BY_FEATURE`). Replicated here as part of moving the
 * `hasAccessToFeature` gate off GraphQL — see PLAT-10688 / PLAT-10626. Keep in
 * sync with the server-side list until the logic is consolidated behind a REST
 * endpoint (PLAT-10688 Option A).
 */
export const RESTRICTED_STATES_BY_FEATURE = {
  [AppFeature.LEASES]: new Set(['OR', 'WA']),
} satisfies Partial<Record<AppFeature, Set<string>>>;
